import { TypePolicy } from '@apollo/client'
export const nuggetTypePolicy = {
    Nugget: {
        keyFields: false,
    } as TypePolicy,
}
